<template>
  <ul class="flex flex-wrap list-reset rounded w-auto font-sans">
    <li v-if="pagination.current_page > 1">
      <a
        class="bg-white block text-gray-800 px-3 py-2 m-1 cursor-pointer"
        @click.prevent="change(pagination.current_page -1)"
      >
        <font-awesome-icon icon="arrow-left"  class="mr-2"/>
      </a>
    </li>
    <li v-for="page in pages" :key="page">
      <a
        class="cursor-pointer"
        :class="[page == pagination.current_page ?
        'bg-indigo-400 rounded text-white  bg-blue  border-blue'
        :'bg-white rounded hover:text-gray-800 hover:bg-blue text-gray-500 border-grey-light', 'font-bold block px-4 m-1 py-2']"
        @click.stop="change(page)"
      >{{ page }}</a>
    </li>
    <li v-if="pagination.current_page < pagination.last_page">
      <a
        class="bg-white block text-gray-800   px-3 py-2 m-1 cursor-pointer"
        @click.prevent="change(pagination.current_page + 1)"
      >
      <font-awesome-icon icon="arrow-right"  class="mr-2"/>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pages () {
      if (!this.pagination.to) {
        return null
      }
      let from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      let to = from + this.offset * 2
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      const pages = []
      for (let page = from; page <= to; page++) {
        pages.push(page)
      }
      return pages
    }
  },
  methods: {
    change: function (page) {
      this.pagination.current_page = page
      this.$emit('paginate')
    }
  }
}
</script>
